import { AnchoredPopover } from "@foodpilot/foods";
import { MenuItemType } from "./ActionsPopover.types";
import RowMenu from "./RowMenu";

type ActionsPopoverProps = {
    menuItems: MenuItemType[];
    anchor: HTMLElement | null;
    closeWindow: () => void;
};

const ActionsPopover = ({ menuItems, anchor, closeWindow }: Readonly<ActionsPopoverProps>) => {
    const isRowMenuOpen = Boolean(anchor);

    return (
        <AnchoredPopover
            variant="themed"
            anchor={anchor}
            open={isRowMenuOpen}
            onClose={closeWindow}
            anchorPosition="rightside"
        >
            <RowMenu menuItems={menuItems} />
        </AnchoredPopover>
    );
};

export default ActionsPopover;
